module.exports = __webpack_public_path__ + "img/anx-logo.a047671a.svg";